import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class ManagersService extends BaseService {
  static get entity() {
    return 'managers'
  }

  static async create(payload = {}) {
    try {
      const response = await this.request({ auth: true }).post(`${this.entity}`, {
        ...payload,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getById({ id }) {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getList(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}?${this.querystring(params)}`
      )

      const data = {
        content: response.data.data,
        total: response.data.total,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async destroy({ id }) {
    try {
      const response = await this.request({ auth: true }).delete(`${this.entity}/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async restore({ id }) {
    try {
      const response = await this.request({ auth: true }).patch(`${this.entity}/restore/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async update({ id, payload = {} }) {
    try {
      const response = await this.request({ auth: true }).put(`${this.entity}/${id}`, {
        ...payload,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async updateAbilities({ id, payload = {} }) {
    try {
      const response = await this.request({ auth: true }).put(
        `${this.entity}/${id}/abilitiesUpdate`,
        {
          ...payload,
        }
      )

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
